import styled from 'styled-components';
import { Media } from '../../../../styles/media';

const { tabletUp } = Media;

export const Container = styled.div``;

export const FooterMenuContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-gap: 16px;

  ${tabletUp`
    grid-template-rows: repeat(6, 1fr);
    grid-auto-flow: column;
  `};

  li {
    margin: 0;
  }

  li span {
    color: ${({ theme }) => theme.medGray};
    font-size: 14px;
    font-weight: 700;
    margin: 0;
  }
`;
